import { render, staticRenderFns } from "./Nuevo.vue?vue&type=template&id=6fa6bd3c&scoped=true&"
import script from "./Nuevo.vue?vue&type=script&lang=ts&"
export * from "./Nuevo.vue?vue&type=script&lang=ts&"
import style0 from "./Nuevo.vue?vue&type=style&index=0&id=6fa6bd3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa6bd3c",
  null
  
)

export default component.exports